import './LHWidget';
import Util from './Util';
import {lhdomelements as LHDOMElements} from './LHDOMElements';
import cssjs from './cssparse';
import SWorker from 'simple-web-worker'

var cssJs = new cssjs.cssjs()
const strStripComments = cssJs.stripComments.toString()
const strParseCSS = cssJs.parseCSS.toString()
const strParseRules = cssJs.parseRules.toString()
const strGetCSSForEditor = cssJs.getCSSForEditor.toString()
const strGetSpaces = cssJs.getSpaces.toString()
const strGetCSSOfRules = cssJs.getCSSOfRules.toString()

var EmbeddedWidget = function (id, type, htmlVariables, cssVariables, jsVariables) {
  Promise.all(Util.getPromisesByUrls(id)).then(results => {
      Util.console.log(`Load html, css, js ${id}`)

      var html = results[0]
      var css = results[1]
      var js = results[2]

      // Make widget html container
      var widgetContainer = document.createElement('div');
      // Add id
      widgetContainer.id = 'lhWidgetItem-' + id;
      // Add widget type in data attribute
      widgetContainer.dataset.widgetType = type;
      // Add class name
      widgetContainer.className = 'lhWidgetItem lhWidgetItem-' + type;
      // Append html into the end of widgetContainer element
      widgetContainer.insertAdjacentHTML('beforeEnd', html);
      // Append widgetContainer element to document.body
      document.body.appendChild(widgetContainer);

      // Make style tag
      var style = document.createElement('style');
      // Insert compiled style into style tag
      style.textContent = css;
      style.id = 'lhWidgetCss-' + id;
      // Append style into the end of document.head
      document.head.appendChild(style);

      // Make script tag
      var script = document.createElement('script');
      // Insert js code into script tag
      script.textContent = js;
      script.id = 'lhWidgetCss-' + id;
      //script.type = 'text/template';
      // Append script into the end of document.body
      document.body.appendChild(script);

  }).catch(error => {
      Util.console.error(error)
  });
}

var IframeWidget = function (id, type, htmlVariables, cssVariables, jsVariables) {

  Promise.all(Util.getPromisesByUrls(id)).then(results => {
      Util.console.log(`Load html, css, js ${id}`)

      // Insert widget to target
      function compileWidgetAndAppendTarget(target, eventOnLoad = true)
      {
          jsVariables.widgetType = type;
          jsVariables.iframeContainerId = id + '-lh-iframe-container';

          // Make iframe container
          var iframe = document.createElement('iframe');
          iframe.id = jsVariables.iframeContainerId;
          iframe.frameBorder = 0;
          iframe.scrolling = 'no';
          iframe.src = 'about:blank';
          iframe.style.display = 'none';

          target.appendChild(iframe);

          iframe = target.querySelector('[id*="' + jsVariables.iframeContainerId + '"]');

          var html = results[0]
          var css = results[1]
          var js = results[2]

          // Make style tag
          var style = document.createElement('style');
          style.textContent = css;

          //Make script tag
          var script = document.createElement('script');
          script.textContent = js;

          function appendElementsToIframe()
          {
              if ( !iframe.contentWindow.document.body.querySelector('.lhrs-widget') )
              {
                  iframe.contentWindow.document.body.innerHTML = html;
                  iframe.contentWindow.document.head.appendChild(style);
                  iframe.contentWindow.document.body.appendChild(script);
              }
          }

          if ( navigator.userAgent.indexOf("MSIE") > -1 && !window.opera ) {
              iframe.onreadystatechange = function () {
                  if ( iframe.readyState == 'complete' )
                  {
                      appendElementsToIframe();
                  }
              }
          } else {
              iframe.onload = function ()
              {
                  appendElementsToIframe();
              }
          }

          appendElementsToIframe();

      }

      // Check target variable
      if ( jsVariables.target )
      {

          // if target is set
          var target = document.getElementById(jsVariables.target);

          var tryNumber = 0;

          (function tryFindTarget(target) {
              // check target in body
              // if tryNumber < 5 , iframe append to document.body
              if ( (target === null ||  target === undefined) && tryNumber < 5 )
              {
                  // if target not found

                  // set timeout in 5 sec and try append widget to target
                  setTimeout( function () {
                      target = document.getElementById(jsVariables.target);

                      // try again
                      tryFindTarget(target);
                  }, 5000)
              } else {
                  // if target found or tryNumber is greater than 5

                  if ( tryNumber != 5 )
                  {

                      // target found
                      // run func compile widget in target

                      compileWidgetAndAppendTarget( target );

                  }

              }

              tryNumber++
          })(target);

      } else {
          // if target not set
          compileWidgetAndAppendTarget( document.body )
      }

  }).catch(error => {
      Util.console.error(error)
  });
}

var ObjectWidget = function (id, type, htmlVariables, cssVariables, jsVariables) {

  Promise.all(Util.getPromisesByUrls(id)).then(results => {
      Util.console.log(`Load html, css, js ${id}`)       
      jsVariables.widgetType = type;
      jsVariables.iframeContainerId = id + '-lh-iframe-container';

      var html = results[0]
      var css = results[1]
      var js = results[2]

      // Make style tag
      var style = document.createElement('style');
      style.textContent = css;

      //Make script tag
      var script = document.createElement('script');
      script.textContent = js;

      // Make iframe container
      var iframe = document.createElement('iframe');
      iframe.id = jsVariables.iframeContainerId;
      iframe.frameBorder = 0;
      iframe.scrolling = 'no';
      iframe.src = 'about:blank';
      iframe.style.display = 'none';

      // Bind onload handlers
      if (window.addEventListener) {
          iframe.addEventListener('load', appendResourcesToIframe, false);
      } else if (window.attachEvent) {
          iframe.attachEvent('onload', appendResourcesToIframe);
      } else {
          iframe.onload = appendResourcesToIframe;
      }

      // Insert container to target
      var target = document.body;
      if (jsVariables.target) target = document.getElementById(jsVariables.target);

      // Set context
      window.Leadhit.LHWidget.context[id] = {};
      window.Leadhit.LHWidget.context[id].html = htmlVariables;
      window.Leadhit.LHWidget.context[id].css = cssVariables;
      window.Leadhit.LHWidget.context[id].js = jsVariables;

      target.appendChild(iframe);

      function appendResourcesToIframe() {
          iframe.contentWindow.document.body.innerHTML = html;
          iframe.contentWindow.document.head.appendChild(style);
          iframe.contentWindow.document.body.appendChild(script);
      }

  }).catch(error => {
      Util.console.error(error)
  });

}

var ObjectElementWidget = function (id, type, htmlVariables, cssVariables, jsVariables) {

  Promise.all(Util.getPromisesByUrls(id)).then(results => {

      Util.console.log(`Load html, css, js ${id}`)

      var html = results[0]
      var css = results[1]
      var js = results[2]

      function compileWidgetAndAppendTarget (target) {

        var lhdom = new LHDOMElements()

        var strRandomizeName = lhdom.randomizeName.toString()
        var strGenerateId = lhdom.generateId.toString()

        SWorker.run((html, lhdom, jsVariables, type, id, strRandomizeName, strGenerateId) => {


          lhdom.randomizeName = eval('(' + strRandomizeName + ')')
          lhdom.generateId = eval('(' + strGenerateId + ')')
          var saveNames = []

          var devMode = jsVariables['DEV'].match(/disableLHDOMElementsReplacer/gi)
          var isEnableLHDOMElementsReplacer = devMode && devMode.length > 0 ? false : true
          var isEnableSetImportantToStyles  = jsVariables['enableSetImportantStyles'] == '1' || jsVariables['enableSetImportantStyles'] == '' || jsVariables['enableSetImportantStyles'] == undefined;
          var isEnableAnyReplacer = (isEnableLHDOMElementsReplacer && isEnableSetImportantToStyles) || (!isEnableLHDOMElementsReplacer && isEnableSetImportantToStyles);

          lhdom.isEnableLHDOMElementsReplacer = isEnableLHDOMElementsReplacer;
          jsVariables.widgetType = type;

          var widgetId = saveNames[ 'lhWidgetItem-' + id ] = lhdom.randomizeName('lhWidgetItem-' + id)
          var widgetStylesId = saveNames[ 'lhWidgetItem-styles' ] = lhdom.randomizeName('lhWidgetItem-styles')
          var widgetScriptId = saveNames[ 'lhWidgetItem-script' ] = lhdom.randomizeName('lhWidgetItem-script')
          let widgetClassItem = saveNames[ 'lhWidgetItem' ] = lhdom.randomizeName('lhWidgetItem')
          let widgetClassItemType = saveNames[ 'lhWidgetItem-' + type ] = lhdom.randomizeName('lhWidgetItem-' + type)

          var regHtmClassesAndIds = /\s(?:class|id|for)\s*=["'](.+?)["']/g
          html = html.replace(regHtmClassesAndIds, ($0, $1, $2) => {
            let detectAttrType = false
            let fillables = ['id=', 'class=', 'for=']

            for(let i = 0; i < fillables.length; i++) {
              if ( $0.search( fillables[ i ] ) !== - 1 ) {
                detectAttrType = fillables[ i ]
              }
            }
            if ( detectAttrType ) {
              return " " + detectAttrType + "\"" + $1.split(' ').map( (htmlSelector) => {
                if ( !saveNames[ htmlSelector ] ) {
                  saveNames[ htmlSelector ] = lhdom.randomizeName(htmlSelector)
                }
                return saveNames[ htmlSelector ]
              }).join(' ') + "\""
            } else {
              return $0
            }
          })

          var result = { 'widgetScriptId': widgetScriptId, 'widgetStylesId': widgetStylesId, 'saveNames': saveNames, 'widgetId': widgetId, 'widgetClassItem': widgetClassItem, 'widgetClassItemType': widgetClassItemType, 'isEnableLHDOMElementsReplacer':lhdom.isEnableLHDOMElementsReplacer, 'html': html }
          return result

        }, [html, lhdom, jsVariables, type, id, strRandomizeName, strGenerateId])
          .then(function(result) {

            lhdom.isEnableLHDOMElementsReplacer = result.isEnableLHDOMElementsReplacer

            var strGetStyleTagByCSSText = Util.getStyleTagByCSSText.toString()
            SWorker.run(function (strStripComments, strParseCSS, strGetCSSForEditor, strGetStyleTagByCSSText, css, saveNames, strRandomizeName, id, strGetSpaces, strGetCSSOfRules, strParseRules, strGenerateId, isEnableLHDOMElementsReplacer) {

              var parseRules = eval('(' + strParseRules + ')')
              var stripComments = eval('(' + strStripComments + ')')
              var parseCSS = eval('(' + strParseCSS + ')')
              var getCSSForEditor = eval('(' + strGetCSSForEditor + ')')
              var randomizeName = eval('(' + strRandomizeName + ')')
              var getSpaces = eval('(' + strGetSpaces + ')')
              var getCSSOfRules = eval('(' + strGetCSSOfRules + ')')
              var getStyleTagByCSSText = eval('(' + strGetStyleTagByCSSText + ')')
              var generateId = eval('(' + strGenerateId + ')')

              var styleObject = getStyleTagByCSSText(css, saveNames, randomizeName, id, stripComments, parseCSS, getCSSForEditor, getSpaces, getCSSOfRules, parseRules, generateId, isEnableLHDOMElementsReplacer)
              return styleObject
  
            }, [strStripComments, strParseCSS, strGetCSSForEditor, strGetStyleTagByCSSText, css, result.saveNames, strRandomizeName, id, strGetSpaces, strGetCSSOfRules, strParseRules, strGenerateId, lhdom.isEnableLHDOMElementsReplacer])
              .then(function(styleObject) {

                var style = lhdom.createStyle({
                    id : result.widgetStylesId,
                    textContent : styleObject.css
                })

                var script = lhdom.createScript({
                  id : result.widgetScriptId,
                  textContent : js,
                  async: true
                })

                var widgetContainer = lhdom.createElement({
                    id : result.widgetId,
                    dataset : {
                        widgetType : type
                    },
                    classes: [
                      result.widgetClassItem,
                      result.widgetClassItemType
                    ]
                })

                jsVariables.targetElement = target
                jsVariables.widgetSelectorId = result.widgetId

                lhdom.insertObjectsToArray({
                    html : htmlVariables,
                    css : cssVariables,
                    js : jsVariables,
                    names : styleObject.saveNames,
                    LHDOMElements: lhdom
                }, window.Leadhit.LHWidget.context, id)
                
                widgetContainer.insertAdjacentHTML('beforeEnd', result.html)

                lhdom.appendToChild(target, [
                    widgetContainer,
                    style,
                    script
                ])

              })

          })

      }

      var target = document.body;
      if (jsVariables.target && jsVariables.widget_type !== 'window') {
        target = document.querySelector(jsVariables.target) || document.getElementById(jsVariables.target)
        if (!target) {
          var tryNumber = 0;

          (function tryFindTarget(target) {
            if ( (target === null ||  target === undefined) && tryNumber < 5 ) {
              setTimeout( function () {
                target = document.querySelector(jsVariables.target) || document.getElementById(jsVariables.target)
                tryFindTarget(target)
              }, 5000)
            }
            else {
              if ( tryNumber != 5 ) {
                compileWidgetAndAppendTarget(target)
              }
              else {
                Util.console.log(`jsVariables.target "${jsVariables.target}" is not found on page`)
              }
            }

            tryNumber++
          })(target);
        }
        else {
          compileWidgetAndAppendTarget(target)
        }
      }
      else {
        compileWidgetAndAppendTarget(target)
      }

  }).catch(error => {
      console.error(error)
  });
}

export default {
  ObjectElementWidget,
  ObjectWidget,
  IframeWidget,
  EmbeddedWidget
}